import { css } from "@emotion/css";

export const spinnerContainer = css`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  @keyframes spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .loading-spinner {
    margin: 0 auto;
    width: 50px;
    height: 50px;
    border: 10px solid #f3f3f3; /* Light grey */
    border-top: 10px solid #f88932; /* Black */
    border-radius: 50%;
    animation: spinner 1.5s linear infinite;
  }
`;
